import settings from '../settings';
import api from './base';
import { AxiosResponse, Canceler } from 'axios';
import {
  ISearchResultDto,
  IPopularKeywordsResponseDto,
  IPopularKeywordDto,
  ISuggestion,
  ILateNightKeyword,
  IApiResult,
  ISuggestionSourceType,
  IStory,
  ISeason,
} from '../types';

export function searchByKeyword(keyword: string): Promise<AxiosResponse<ISearchResultDto>> {
  const uri = `${settings.getApiURI()}/search/v2/universal?keyword=${encodeURI(keyword)}`;

  return api.http.get(uri);
}

export function searchStoriesByTitle(title: string, limit: number): [Promise<AxiosResponse<{ items: IStory[]; totalCount: number }>>, Canceler] {
  const uri = `${settings.getApiURI()}/story-admin/v3/stories?q=${encodeURI(title)}&limit=${limit}&excludeArchived=true&type=title&sort=id&order=asc`;

  return api.getWithCancel(uri);
}

export function searchSeasonsByTitle(title: string, limit: number): [Promise<AxiosResponse<{ items: ISeason[]; totalCount: number }>>, Canceler] {
  const uri = `${settings.getApiURI()}/story-admin/v3/seasons?q=${encodeURI(title)}&limit=${limit}&type=title&sort=id&order=asc`;

  return api.getWithCancel(uri);
}

export function getTopSearchKeywords(duration = 7): Promise<AxiosResponse<IPopularKeywordsResponseDto>> {
  const uri = `${settings.getApiURI()}/search/v2/keywords/stat?duration=${duration}`;

  return api.http.get(uri);
}

export function getPopularKeywords(): Promise<AxiosResponse<string[]>> {
  const uri = `${settings.getApiURI()}/search/v2/keywords/popular`;

  return api.http.get(uri);
}

export function savePopularKeywords(keywords: IPopularKeywordDto[]): Promise<AxiosResponse<IPopularKeywordDto>> {
  const uri = `${settings.getApiURI()}/search/v2/keywords/popular`;

  return api.http.post(uri, keywords);
}

export function autoComplete(keyword: string, type?: ISuggestionSourceType, allowDuplicate = false): Promise<AxiosResponse<ISuggestion[]>> {
  const uri = `${settings.getApiURI()}/search/v2/auto-complete`;

  return api.silentHttp.get(uri, { params: { keyword, type, skipDuplicate: allowDuplicate ? false : undefined } });
}

export function getLateNightKeywords(): Promise<AxiosResponse<ILateNightKeyword[]>> {
  const uri = `${settings.getApiURI()}/search/v2/keywords/late-night`;

  return api.http.get(uri);
}

export function addLateNightKeyword(keyword: string): Promise<AxiosResponse<IApiResult<ILateNightKeyword>>> {
  const uri = `${settings.getApiURI()}/search/v2/keywords/late-night`;

  return api.http.post(uri, {
    keyword,
  });
}

export function deleteLateNightKeywordById(id: number) {
  const uri = `${settings.getApiURI()}/search/v2/keywords/late-night/${id}`;

  return api.http.delete(uri);
}
